import { createSlice } from '@reduxjs/toolkit';
import {
  getSurveyAnswersSucceededAction,
  getSurveyQuestionsSucceededAction,
  holdSurveyAnswersAction,
  putSurveyAnswersSucceededAction
} from './Actions';
import { surveyQuestionsInitialState } from './State';
import {
  getSurveyAnswersSucceededReducer,
  getSurveyQuestionsSucceededReducer, holdSurveyAnswerReducer, putSurveyAnswersSucceededReducer,
} from './Reducers';

export const surveyQuestionSlice = createSlice({
  name: 'surveyQuestions',
  initialState: surveyQuestionsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSurveyQuestionsSucceededAction, getSurveyQuestionsSucceededReducer)
      .addCase(putSurveyAnswersSucceededAction, putSurveyAnswersSucceededReducer)
      .addCase(getSurveyAnswersSucceededAction, getSurveyAnswersSucceededReducer)
      .addCase(holdSurveyAnswersAction, holdSurveyAnswerReducer);
  },
});
